// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","532":"styles","802":"94726e6d"}[chunkId] || chunkId) + "-" + {"230":"20a593ee5eea0277d524","532":"d94bbb525ded7375d9de","740":"22ce8dc5193afb51e612","802":"5c40608f91e281b6360f"}[chunkId] + ".js";
};